import "../../scss/pc/common_rem.scss";
import "../../scss/pc/index_rem.scss";

import Slider from "./Slider";
import dialogInit from  "./dialog";
import headerInit from  "./_header";

dialogInit();
headerInit();

let imgSlider = new Slider(".j-ship-slider-list");
let switcher = document.querySelectorAll(".j-ship-slider-item");
imgSlider.max = switcher.length -1;

document.querySelectorAll(".j-slide-btn").forEach((item,index)=>{
    imgSlider.appendSwitcher(item,index)
})

imgSlider.onShowIndex = function(index){
    document.querySelectorAll(".j-slide-btn").forEach((item,curIndex)=>{
        if(curIndex != index){
            item.className = item.className.replace(/\scur/,"");
        }else if(!/cur/.test(item.className)){
            item.className += " cur"
        }
    })
}
imgSlider.setTimer();

document.querySelector(".j-vedio-close-btn").addEventListener("click",function(){
    document.querySelector(".j-vedio-container").style.display = "none";
    document.querySelector(".j-vedio-iframe").src = "";
})

document.querySelector(".j-vedio-bg").addEventListener("click",function(){
    document.querySelector(".j-vedio-container").style.display = "none";
    document.querySelector(".j-vedio-iframe").src = "";
})


document.querySelector(".j-show-vedio").addEventListener("click",function(){
    document.querySelector(".j-vedio-container").style.display = "block";
    document.querySelector(".j-vedio-iframe").src = "https://www.youtube.com/embed/aiW--VkCqzk?enablejsapi=1&rel=0&loop=1&autoplay=1&controls=1&playlist=aiW--VkCqzk";
})


let newItems = document.querySelectorAll(".j-new-block1");


let newblock1 = new Slider(".j-news-list-block1",".j-article-switcher-btn-prev",".j-article-switcher-btn-next",newItems.length - 1);
let newblock2= new Slider(".j-news-list-block2",".j-article-switcher-btn-prev",".j-article-switcher-btn-next",newItems.length );
newblock2.min = 1;

let imgSliderwidth = document.querySelector(".j-ship-slider-inner").clientWidth;
let newItemswidth = document.querySelector(".j-block1").clientWidth;
imgSlider.init(imgSliderwidth)
newblock1.init(newItemswidth)
newblock2.init(newItemswidth)


window.addEventListener("load",function(){
    setTimeout(initSliders,400)
})
function initSliders(){
    let imgSliderwidth = document.querySelector(".j-ship-slider-inner").clientWidth;
    let newItemswidth = document.querySelector(".j-block1").clientWidth;
    imgSlider.slideW = imgSliderwidth;
    newblock1.slideW = newItemswidth;
    newblock2.slideW = newItemswidth;
    newblock2.showNext();
}

window.addEventListener("resize",initSliders)



